import { Space, Table, Tag } from "antd";
import React from "react";


const columns = [
  {
    title: "发件人",
    dataIndex: "sender",
    key: "sender",
    width: "120px",
  },
  {
    title: "主题",
    dataIndex: "subject",
    key: "subject",
    render: (text, record) => (
      <a
        href={`http://i.sudytech.cn/_web/fusionportal/messageCenter/detailInfo.html?id=${record?.id}&_p=YXM9MSZwPTEmbT1OJg__`}
      >
        {text}
      </a>
    ),
  },
  {
    title: "时间",
    dataIndex: "createTime",
    key: "createTime",
  },
];

const data = [
  {
    sender: "流程",
    id: "6497e1b57e657b002639d4c0",
    state: true,
    subject: "李志梅项目类报销申请流程状态变更提醒",
    content:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【财务处支付确认】环节\n上一步办理情况：上一步处理人：王平,处理时间：2023-06-25 14:41:56，处理意见：送财务处支付确认。",
    contentText:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【财务处支付确认】环节\n上一步办理情况：上一步处理人：王平,处理时间：2023-06-25 14:41:56，处理意见：送财务处支付确认。",
    createTime: "2023-06-25 14:41",
    msgRequired: "false",
    msgLinkUrl: "",
    urlTarget: "",
    publishEndTime: "",
    publishStartTime: "",
  },
  {
    sender: "流程",
    id: "6497e1b47e657b002639d4a3",
    state: true,
    subject: "项目类报销申请",
    content:
      "您2023-06-20 16:44:05发起的项目类报销申请已经通过相关审批，请您及时提供相关单据至财务处！",
    contentText:
      "您2023-06-20 16:44:05发起的项目类报销申请已经通过相关审批，请您及时提供相关单据至财务处！",
    createTime: "2023-06-25 14:41",
    msgRequired: "false",
    msgLinkUrl: "",
    urlTarget: "",
    publishEndTime: "",
    publishStartTime: "",
  },
  {
    sender: "流程",
    id: "6497e1927e657b002639d428",
    state: true,
    subject: "李志梅项目类报销申请流程状态变更提醒",
    content:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【总经理审批】环节\n上一步办理情况：上一步处理人：王平,处理时间：2023-06-25 14:41:21，处理意见：送总经理审批。",
    contentText:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【总经理审批】环节\n上一步办理情况：上一步处理人：王平,处理时间：2023-06-25 14:41:21，处理意见：送总经理审批。",
    createTime: "2023-06-25 14:41",
    msgRequired: "false",
    msgLinkUrl: "",
    urlTarget: "",
    publishEndTime: "",
    publishStartTime: "",
  },
  {
    sender: "流程",
    id: "64926d3b7e657b002639b5f2",
    state: true,
    subject: "李志梅项目类报销申请流程状态变更提醒",
    content:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【业务单元负责人审批】环节\n上一步办理情况：上一步处理人：祖抗,处理时间：2023-06-21 11:23:38，处理意见：送业务单元负责人审批。",
    contentText:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【业务单元负责人审批】环节\n上一步办理情况：上一步处理人：祖抗,处理时间：2023-06-21 11:23:38，处理意见：送业务单元负责人审批。",
    createTime: "2023-06-21 11:23",
    msgRequired: "false",
    msgLinkUrl: "",
    urlTarget: "",
    publishEndTime: "",
    publishStartTime: "",
  },
  {
    sender: "流程",
    id: "64926c967e657b002639b5da",
    state: true,
    subject: "李志梅项目类报销申请流程状态变更提醒",
    content:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【部门领导审批】环节\n上一步办理情况：上一步处理人：俞坚,处理时间：2023-06-21 11:20:53，处理意见：送部门领导审批。",
    contentText:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【部门领导审批】环节\n上一步办理情况：上一步处理人：俞坚,处理时间：2023-06-21 11:20:53，处理意见：送部门领导审批。",
    createTime: "2023-06-21 11:20",
    msgRequired: "false",
    msgLinkUrl: "",
    urlTarget: "",
    publishEndTime: "",
    publishStartTime: "",
  },
  {
    sender: "流程",
    id: "64923ca47e657b002639b17b",
    state: true,
    subject: "李志梅项目类报销申请流程状态变更提醒",
    content:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【项目负责人审批】环节\n上一步办理情况：上一步处理人：李旻,处理时间：2023-06-21 07:56:19，处理意见：送项目负责人审批。",
    contentText:
      "您发起的项目类报销申请【李志梅项目类报销申请】，处理号：BXSQ202306200018。已发送至【项目负责人审批】环节\n上一步办理情况：上一步处理人：李旻,处理时间：2023-06-21 07:56:19，处理意见：送项目负责人审批。",
    createTime: "2023-06-21 07:56",
    msgRequired: "false",
    msgLinkUrl: "",
    urlTarget: "",
    publishEndTime: "",
    publishStartTime: "",
  },
  {
    sender: "流程",
    id: "649166d57e657b002639acae",
    state: true,
    subject: "李志梅项目类报销申请流程申请提醒",
    content: "您发起的【项目类报销申请】流程已经提交成功",
    contentText: "您发起的【项目类报销申请】流程已经提交成功",
    createTime: "2023-06-20 16:44",
    msgRequired: "false",
    msgLinkUrl: "",
    urlTarget: "",
    publishEndTime: "",
    publishStartTime: "",
  },
];

const NewsCard = ({ msg }) => (
  <Table
    columns={columns}
    dataSource={data}
    pagination={{ defaultPageSize: 5 }}
  />
);
export default NewsCard;
